import React, { useEffect, useState } from 'react';
import { postAPI } from '../../api';
import SidebarSection from './SidebarSection';
import PostList from './PostList';

interface Post {
  post_id: number;
  title: string;
  createdAt: string;
  commentCount: number;
}

const RecentPostsSection: React.FC<{
  limit?: number;
  boardId?: number;
  title?: string;
  noDataText?: string;
}> = ({
  limit = 5,
  boardId = undefined,
  title = '최신글',
  noDataText = '최신글이 없습니다.'
}) => {
  const [recentPosts, setRecentPosts] = useState<Post[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchRecentPosts = async () => {
      try {
        setLoading(true);
        const response = await postAPI.getPostList(1, limit, '', 0, boardId);
        const postsData = response.data.posts || response.data;
        
        // 최근 게시물 5개만 표시
        setRecentPosts(postsData.slice(0, limit));
      } catch (error) {
        console.error('최근 게시물 로딩 오류:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchRecentPosts();
  }, []);

  return (
    <SidebarSection title={title} moreLink={boardId ? `/boards/${boardId}` : undefined}>
      <PostList 
        posts={recentPosts} 
        noDataText={noDataText}
      />
    </SidebarSection>
  );
};

export default RecentPostsSection; 